(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ps-offer"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('ps-offer-block')) return;
    const OPEN = '{' + '{';
    const CLOSE = '}' + '}';
    const fallback = '$' + OPEN + 'amount' + CLOSE;
    const re = new RegExp(OPEN + '\\s*(\\w+)\\s*' + CLOSE);
    function formatMoney(cents, format) {
      const value = cents / 100;
      const m = re.exec(format || fallback);
      const key = m ? m[1] : 'amount';
      function num(v, dec, thou, decSep) {
        const parts = v.toFixed(dec).split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
        return parts.length > 1 ? parts.join(decSep) : parts[0];
      }
      let out;
      switch (key) {
        case 'amount_no_decimals': out = num(value, 0, ',', '.'); break;
        case 'amount_with_comma_separator': out = num(value, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': out = num(value, 0, '.', ','); break;
        case 'amount_with_space_separator': out = num(value, 2, ' ', ','); break;
        case 'amount_no_decimals_with_space_separator': out = num(value, 0, ' ', ','); break;
        case 'amount_with_apostrophe_separator': out = num(value, 2, "'", '.'); break;
        default: out = num(value, 2, ',', '.');
      }
      return (format || fallback).replace(re, out);
    }

    class PsOfferBlock extends HTMLElement {
      connectedCallback() {
        const dataEl = this.querySelector('[data-ps-product]');
        if (!dataEl) return;
        this.data = JSON.parse(dataEl.textContent);
        this.data.variants.forEach((v) => (v.allocations = v.allocations.filter(Boolean)));
        this.format = this.dataset.moneyFormat;
        this.servings = parseInt(this.dataset.servings || '30', 10);
        this.perUnit = this.dataset.perUnit || 'day';
        this.stack = this.dataset.stackDiscount === 'true';
        this.showAtcPrice = this.dataset.atcPrice === 'true';
        this.compareBasis = this.dataset.compareBasis || 'price';

        this.qtyInput = this.querySelector('[data-ps-qty]');
        this.planInput = this.querySelector('[data-ps-plan]');
        this.variantInput = this.querySelector('input[name="id"]');
        this.tiers = Array.from(this.querySelectorAll('[data-ps-tier]'));
        this.purchase = this.querySelector('[data-ps-purchase]');
        this.subDetails = this.querySelector('[data-ps-sub-details]');
        this.typeInputs = Array.from(this.querySelectorAll('[data-ps-purchase-type]'));
        this.planChoices = Array.from(this.querySelectorAll('[data-ps-plan-choice]'));
        this.atcPrice = this.querySelector('[data-ps-atc-price]');
        this.atcCompare = this.querySelector('[data-ps-atc-compare]');
        this.priceOnce = this.querySelector('[data-ps-price-onetime]');
        this.priceSub = this.querySelector('[data-ps-price-sub]');
        this.stickyPrice = this.querySelector('[data-ps-sticky-price]');
        this.savePill = this.querySelector('[data-sub-save-pill]');
        this.optionInputs = Array.from(this.querySelectorAll('[data-ps-option]'));

        this.tiers.forEach((t) => t.addEventListener('change', () => this.update()));
        this.typeInputs.forEach((r) => r.addEventListener('change', () => this.update()));
        this.switchBtn = this.querySelector('[data-ps-purchase-switch]');
        if (this.switchBtn) this.switchBtn.addEventListener('click', () => {
          const on = this.switchBtn.getAttribute('aria-checked') !== 'true';
          const want = on ? 'subscribe' : 'onetime';
          this.typeInputs.forEach((i) => { i.checked = i.value === want; });
          this.update();
        });
        this.planChoices.forEach((r) => r.addEventListener('change', () => this.update()));
        this.optionInputs.forEach((r) => r.addEventListener('change', () => this.onVariantChange()));

        const sticky = this.querySelector('[data-ps-sticky]');
        if (sticky) {
          const btn = sticky.querySelector('[data-ps-sticky-btn]');
          const atcWrap = this.querySelector('.ps-ob__atc');
          btn && btn.addEventListener('click', () => { const atc = this.querySelector('[data-ps-atc]'); atc && atc.click(); });
          if (atcWrap && 'IntersectionObserver' in window) {
            sticky.hidden = false;
            new IntersectionObserver((entries) => {
              const e = entries[0];
              sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top > 0);
            }, { threshold: 0 }).observe(atcWrap);
          }
        }
        if (!this.tiers.some((t) => t.checked) && this.tiers[0]) this.tiers[0].checked = true;
        this.update();
      }
      currentVariant() {
        const id = parseInt(this.variantInput.value, 10);
        return this.data.variants.find((v) => v.id === id) || this.data.variants[0];
      }
      onVariantChange() {
        const selected = [];
        this.optionInputs.forEach((i) => { if (i.checked) selected[parseInt(i.dataset.option, 10)] = i.value; });
        const match = this.data.variants.find((v) => v.options.every((o, i) => o === selected[i]));
        if (!match) return;
        this.variantInput.value = match.id;
        this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        const atc = this.querySelector('[data-ps-atc]');
        if (atc) atc.disabled = !match.available;
        this.update();
      }
      checkedTier() { return this.tiers.find((t) => t.checked) || null; }
      isSubscribe() {
        const tier = this.checkedTier();
        const mode = tier ? tier.dataset.mode : 'follow';
        if (mode === 'subscription') return true;
        if (mode === 'onetime') return false;
        const r = this.typeInputs.find((i) => i.value === 'subscribe');
        return !!(r && r.checked);
      }
      selectedPlan(variant, tierInput) {
        const t = tierInput || this.checkedTier();
        const match = t && t.dataset.planMatch ? t.dataset.planMatch.toLowerCase() : '';
        if (match) {
          const found = variant.allocations.find((a) => String(a.plan_id) === match || (a.plan_name || '').toLowerCase().indexOf(match) !== -1);
          if (found) return found;
        }
        const chosen = this.planChoices.find((r) => r.checked);
        if (chosen) return variant.allocations.find((a) => a.plan_id === parseInt(chosen.value, 10)) || variant.allocations[0] || null;
        return variant.allocations[0] || null;
      }
      update() {
        const v = this.currentVariant();
        const tier = this.checkedTier();
        const mode = tier ? tier.dataset.mode : 'follow';
        const sub = this.isSubscribe();
        const alloc = sub ? this.selectedPlan(v) : null;
        const unitOnce = v.price;
        const unitCompare = this.compareBasis === 'variant' && v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : v.price;
        const unitSub = alloc ? alloc.price : unitOnce;

        /* lock the toggle when the tier decides the purchase type */
        this.dataset.tierLocked = mode !== 'follow' ? 'true' : 'false';
        if (mode !== 'follow') {
          this.typeInputs.forEach((i) => { i.checked = (i.value === 'subscribe') === sub; });
        }
        if (this.switchBtn) this.switchBtn.setAttribute('aria-checked', sub ? 'true' : 'false');
        if (this.purchase) this.purchase.dataset.sub = sub ? 'true' : 'false';
        if (this.subDetails) this.subDetails.hidden = !sub && !this.switchBtn;
        if (this.planInput) {
          if (sub && alloc) { this.planInput.value = alloc.plan_id; this.planInput.disabled = false; }
          else { this.planInput.value = ''; this.planInput.disabled = true; }
        }
        if (this.savePill) {
          const first = v.allocations[0];
          this.savePill.textContent = first && first.price < unitOnce ? 'Save ' + Math.round((1 - first.price / unitOnce) * 100) + '%' : '';
        }

        let activeTotal = null;
        let activeCompare = 0;
        this.tiers.forEach((input) => {
          const qty = parseInt(input.dataset.qty, 10) || 1;
          const paid = parseInt(input.dataset.paid, 10) || qty;
          const tMode = input.dataset.mode || 'follow';
          const tSub = tMode === 'subscription' ? true : tMode === 'onetime' ? false : sub;
          const tAlloc = tSub ? this.selectedPlan(v, input) : null;
          const override = parseInt(input.dataset.price, 10) || 0;
          const overrideCompare = parseInt(input.dataset.compare, 10) || 0;
          const card = input.nextElementSibling;
          let total, compare;
          if (override > 0) {
            total = override;
            compare = overrideCompare > 0 ? overrideCompare : unitCompare * qty;
          } else if (tSub && tAlloc) {
            total = this.stack ? tAlloc.price * paid : tAlloc.price * qty;
            compare = unitCompare * qty;
          } else {
            total = unitOnce * paid;
            compare = unitCompare * qty;
          }
          const hideCmp = input.dataset.hideCompare === 'true';
          card.querySelector('[data-tier-price]').textContent = formatMoney(total, this.format);
          card.querySelector('[data-tier-compare]').textContent = !hideCmp && compare > total ? formatMoney(compare, this.format) : '';
          let each = '';
          if (this.perUnit === 'day' && this.servings > 0) each = formatMoney(Math.round(total / (this.servings * qty)), this.format) + '/day';
          else if (this.perUnit === 'unit' && qty > 1) each = formatMoney(Math.round(total / qty), this.format) + ' each';
          card.querySelector('[data-tier-each]').textContent = each;
          const pct = compare > total ? Math.round((1 - total / compare) * 100) : 0;
          const saveEl = card.querySelector('[data-tier-save]');
          const label = input.dataset.saveLabel || '';
          saveEl.textContent = label ? label : (pct > 0 ? 'Save ' + pct + '%' : '');
          if (input.checked) { activeTotal = total; activeCompare = compare; if (this.qtyInput) this.qtyInput.value = qty; }
        });

        if (activeTotal === null) { activeTotal = sub && alloc ? unitSub : unitOnce; activeCompare = unitCompare; }
        const txt = formatMoney(activeTotal, this.format);
        if (this.atcPrice) this.atcPrice.textContent = txt;
        if (this.atcCompare) this.atcCompare.textContent = activeCompare > activeTotal ? formatMoney(activeCompare, this.format) : '';
        if (this.stickyPrice) this.stickyPrice.textContent = txt;
        /* per-type prices for the current tier (radio / pills styles) */
        if (this.priceOnce || this.priceSub) {
          const qty = tier ? parseInt(tier.dataset.qty, 10) || 1 : 1;
          const paid = tier ? parseInt(tier.dataset.paid, 10) || qty : 1;
          const firstAlloc = v.allocations[0];
          if (this.priceOnce) this.priceOnce.textContent = formatMoney(unitOnce * paid, this.format);
          if (this.priceSub) this.priceSub.textContent = firstAlloc ? formatMoney(this.stack ? firstAlloc.price * paid : firstAlloc.price * qty, this.format) : '';
        }
      }
    }
    customElements.define('ps-offer-block', PsOfferBlock);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ps-reviews"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('ps-reviews')) return;
    class PsReviews extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-rv-track]');
        this.slides = Array.from(this.querySelectorAll('[data-rv-slide]'));
        this.dotsWrap = this.querySelector('[data-rv-dots]');
        this.prev = this.querySelector('[data-rv-prev]');
        this.next = this.querySelector('[data-rv-next]');
        this.autoplay = this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.interval = parseInt(this.dataset.interval || '6000', 10);
        this.loop = this.dataset.loop === 'true';
        this.i = 0;
        if (!this.track || !this.slides.length) return;

        if (this.dotsWrap) {
          this.slides.forEach((_, k) => {
            const b = document.createElement('button');
            b.type = 'button';
            b.setAttribute('aria-label', 'Go to review ' + (k + 1));
            b.appendChild(document.createElement('i'));
            b.addEventListener('click', () => this.go(k, true));
            this.dotsWrap.appendChild(b);
          });
          this.dots = Array.from(this.dotsWrap.children);
        }
        this.prev && this.prev.addEventListener('click', () => this.go(this.i - 1, true));
        this.next && this.next.addEventListener('click', () => this.go(this.i + 1, true));

        /* swipe */
        let x0 = null;
        this.track.addEventListener('pointerdown', (e) => { x0 = e.clientX; });
        this.track.addEventListener('pointerup', (e) => {
          if (x0 === null) return;
          const dx = e.clientX - x0; x0 = null;
          if (Math.abs(dx) > 40) this.go(this.i + (dx < 0 ? 1 : -1), true);
        });
        this.addEventListener('pointerenter', () => { this.paused = true; });
        this.addEventListener('pointerleave', () => { this.paused = false; });

        this.go(0);
        this.restart();
      }
      go(k, user) {
        const n = this.slides.length;
        if (this.loop) k = (k + n) % n; else k = Math.max(0, Math.min(n - 1, k));
        this.i = k;
        this.track.style.transform = 'translateX(' + (-k * 100) + '%)';
        this.slides.forEach((s, j) => s.classList.toggle('is-active', j === k));
        if (this.dots) this.dots.forEach((d, j) => {
          d.setAttribute('aria-current', j === k ? 'true' : 'false');
          const bar = d.querySelector('i');
          if (bar && j === k) { bar.style.transition = 'none'; bar.style.transform = 'scaleX(0)'; void bar.offsetWidth; bar.style.transition = ''; bar.style.transform = ''; }
        });
        if (!this.loop) {
          if (this.prev) this.prev.disabled = k === 0;
          if (this.next) this.next.disabled = k === n - 1;
        }
        if (user) this.restart();
      }
      restart() {
        if (!this.autoplay || this.slides.length < 2) return;
        clearInterval(this.timer);
        this.timer = setInterval(() => { if (!this.paused) this.go(this.i + 1); }, this.interval);
      }
      disconnectedCallback() { clearInterval(this.timer); }
    }
    customElements.define('ps-reviews', PsReviews);
  })();
  } catch(e) { console.error(e); }
})();

})();
